export default __webpack_public_path__ + "static/wordpress-cdb822bcdad193741764fdda4f90b45f.png";